import { getEditorInfo } from "src/common/attrEdit";
import { getViewInfo } from "src/common/attrView";
import { AttrTypeName } from "src/types/AttrType";
import { MakeLabelParams } from "../types/MakeLabelParams";

type KeyGenFn = (params: MakeLabelParams) => string[];

/**
 * для простых типов, у которых вид задается только компонентом отображения
 */
const onViewType: KeyGenFn = (params: MakeLabelParams) => {
  const { attribute } = params;
  const viewInfo = getViewInfo(attribute.viewType);
  return [viewInfo?.component?.view].filter((e) => !!e) as string[];
};

/**
 * для типов, у которых вид задается компонентом отображения и редактирования (есть и такая зависимость)
 */
const onViewAndEditor: KeyGenFn = (params: MakeLabelParams) => {
  const { attribute } = params;
  const viewInfo = getViewInfo(attribute.viewType);
  const editorInfo = getEditorInfo(attribute.viewStyles);
  return [viewInfo?.component?.view, editorInfo?.component?.editor].filter(
    (e) => !!e,
  ) as string[];
};

/**
 * порядок играет роль!
 * сначала располагаются наиболее специфичные варианты, а последним идет дефолтный
 * проверка на свопадение происходит по каскаду и берется первый совпавший
 */
const keygenMap: Record<AttrTypeName, KeyGenFn[]> = {
  [AttrTypeName.article]: [onViewType],
  [AttrTypeName.boolean]: [onViewType],
  [AttrTypeName.childEntities]: [onViewType],
  [AttrTypeName.contentLanguage]: [onViewType],
  [AttrTypeName.date]: [onViewType],
  [AttrTypeName.dateTime]: [onViewType],
  [AttrTypeName.dictMulti]: [onViewType],
  [AttrTypeName.dictSingle]: [onViewType],
  [AttrTypeName.externalLink]: [onViewType],
  [AttrTypeName.file]: [onViewType],
  [AttrTypeName.financial]: [onViewType],
  [AttrTypeName.formula]: [onViewType],
  [AttrTypeName.image]: [onViewType],
  [AttrTypeName.int]: [onViewType],
  [AttrTypeName.linkedValue]: [onViewType],
  [AttrTypeName.number]: [onViewType],
  [AttrTypeName.object]: [onViewType],
  [AttrTypeName.string]: [onViewAndEditor, onViewType],
  [AttrTypeName.time]: [onViewType],
  [AttrTypeName.usersList]: [onViewType],
};

/**
 * принцип формирования ключей следующий:
 * [factor1, factor2, factorN ...].join('.');
 * возможно расширение, потому что вид лейбла может зависеть от множества факторов
 */
export const extractLabelViewFactors = (params: MakeLabelParams) => {
  const { typesMap, attribute } = params;
  const attrType = typesMap[attribute.valueType] as AttrTypeName;
  const genKey = keygenMap[attrType];
  if (!genKey) return [onViewType(params)];
  return genKey.map((fn) => fn(params));
};

export const genLabelKey = (list: (string | null | undefined)[]): string =>
  list.filter((e) => !!e).join(".");
